import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import Rugilaba from "./pdf/Rugilaba";

function LapRugiLaba() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [selectedModel, setSelectedModel] = useState("bulanan");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const bulanNumber = (selectedBulan + 1).toString().padStart(2, '0');
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;


    setLoading(true);
    try {
      const endpoints = {
        'bulanan':`api/akuntansi/rugilaba/${periode}`,
        'akumulasi':`api/akuntansi/akumulasirugilaba/${periode}`
      }
      const endpoint = endpoints[selectedModel] || endpoints.default;
      const response = await api.get(endpoint);    
      
      if (response.status !== 200) {
        alert(`Server Error`);
        setLoading(false);
        return;
      }
      const result = response.data;
      if (!Array.isArray(result) || result.length === 0) {
        alert(`Data tidak ditemukan untuk periode ${periode}.`);
      } else {
        Rugilaba(result, namaBulan, tahun); // Cetak PDF
      }
    } catch (error) {
      console.error('Gagal mengambil data:', error);
      alert(`Terjadi kesalahan saat mengambil data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: '400px' }}>
            <div className="card-header">
              <h5 className="card-title">Laporan Rugi Laba</h5>
            </div>
            <form className="form-horizontal" onSubmit={handleSubmit}>
              <div className="card-body">     
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Model</label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      value={selectedModel}
                      onChange={(e) => setSelectedModel(e.target.value)}
                    >       
                      <option value="bulanan">Bulanan</option>
                      <option value="akumulasi">Akumlasi</option>               
                    </select>
                  </div>
                </div>         
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={(e) => setSelectedBulan(parseInt(e.target.value))}
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>{item}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>                
              </div>
              <div className="modal-footer pt-1">
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Memproses...' : 'Cetak'}
                </button>
              </div>
            </form>              
          </div>
        </div>
      </div>
    </div>
  );
}

export default LapRugiLaba;
